import { BREAKPOINTS } from '../config';
import { initSlider } from './splide-sett';

const { mqTouch, mqTablet } = BREAKPOINTS;

const mq = window.matchMedia(`(max-width: ${mqTouch}px)`);

// const elemSplide = document.querySelector('.elem');
// if (elemSplide) {
//   initSlider(elemSplide, {
//     perPage: 2,
//     gap: '1.5rem',
//     breakpoints: {
//       [mqTouch]: {},
//       [mqTablet]: {},
//     },
//   });
// }

const baseSplides = document.querySelectorAll('.base-splide');
baseSplides?.forEach(container => {
  initSlider(container, {
    perPage: 3,
    gap: '1.5rem',
    breakpoints: {
      [mqTouch]: {
        perPage: 2,
        gap: '1rem',
      },
      [mqTablet]: {
        perPage: 1,
      },
    },
  });
});

const trafficMainSplides = document.querySelectorAll('.traffic__splide-main');
const trafficSecondSplides = document.querySelectorAll(
  '.traffic__splide-second'
);

trafficMainSplides?.forEach((container, index) => {
  const main = initSlider(container, {
    type: 'loop',
    direction: 'ttb',
    gap: '2rem',
    height: '2.75rem',

    speed: 1500,
    interval: 2000,
    easing: 'ease-in-out',

    autoplay: true,

    drag: false,
    swipe: false,
    keyboard: false,
    wheel: false,

    breakpoints: {
      [mqTouch]: {
        gap: '1.5rem',
        height: '2rem',
      },
      [mqTablet]: {},
    },
  });

  const secondContainer = trafficSecondSplides[index];
  if (!secondContainer) return;

  const second = initSlider(secondContainer, {
    type: 'fade',
    updateOnMove: false,

    speed: 1500,
    interval: 2000,
    easing: 'ease-in-out',

    autoplay: true,

    drag: false,
    swipe: false,
    keyboard: false,
    wheel: false,
  });

  main.sync(second);
});

const embdSplides = document.querySelectorAll('.embd-slider');
embdSplides?.forEach(container => {
  initSlider(container, {
    type: 'fade',
    updateOnMove: false,
    rewind: true,
  });
});

// let elemSliderInstance;
// const elem = document.querySelector('.elem');

// const elemInitSlider = () => {
//   if (elem && !elemSliderInstance) {
//     elemSliderInstance = initSlider(elem, {
//       perPage: 2,
//       gap: '1.5rem',
//       breakpoints: {
//         [mqTouch]: {},
//         [mqTablet]: {},
//       },
//     });
//   }
// };

let growSliderInstances = [];
const grow = document.querySelectorAll('.grow__splide');

const growInitSliders = () => {
  if (grow && !growSliderInstances.length) {
    grow.forEach(container => {
      const slider = initSlider(container, {
        perPage: 2,
        gap: '1rem',
        breakpoints: {
          [mqTouch]: {},
          [mqTablet]: {
            perPage: 1,
          },
        },
      });
      growSliderInstances.push(slider);
    });
  }
};

const destroySliders = () => {
  // if (elemSliderInstance) {
  //   elemSliderInstance.destroy();
  //   elemSliderInstance = null;
  // }
  if (growSliderInstances) {
    growSliderInstances.forEach(instance => {
      instance.destroy();
    });
    growSliderInstances = [];
  }
};

function checkViewport() {
  // elemInitSlider();
  growInitSliders();

  if (!mq.matches) {
    destroySliders();
  }
}

mq.addEventListener('change', checkViewport);
document.addEventListener('DOMContentLoaded', checkViewport);
